import { useQuery } from 'react-query';

import { axios } from 'lib';

const getLevelStructures = (resource, id) => {
  return axios.get(`/api/${resource}/${id}/setup/level_structures`);
};

export const useLevelStructures = (resource, id, options = {}) => {
  return useQuery(
    `${resource}-${id}-setup-level-structures`,
    () => getLevelStructures(resource, id),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
